import React from "react";
import { C } from "../config/theme";
import { ReactComponent as LogoBativiz } from "../assets/logo-bativiz.svg";
import { ReactComponent as LogoMark } from "../assets/logo-mark.svg";
import { IcoChevL, IcoChevR, IcoLogout } from "./Icons";

export default function Sidebar({ open, setOpen, clientNom, syncLastRun, nav, activePage, setActivePage, profile, signOut }) {  return (
    <aside style={{
      width: open ? 220 : 64, minWidth: open ? 220 : 64,
      background: C.navy, color: "#fff", display: "flex", flexDirection: "column",
      transition: "width 200ms", overflow: "visible", position: "relative", flexShrink: 0,
    }}>
      <div onClick={() => setOpen(!open)} style={{
        position: "absolute", right: -14, top: 30, width: 28, height: 28, borderRadius: "50%",
        background:"#fff",boxShadow:"0 2px 8px rgba(0,0,0,0.15)",color:"#0D1B2A",
        display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 10,
      }}>
        {open ? <IcoChevL size={15} /> : <IcoChevR size={15} />}
      </div>

      <div style={{
        padding: open ? "16px 20px" : "16px 0",
        display: "flex", alignItems: "center", gap: 12,
        justifyContent: open ? "flex-start" : "center",
        borderBottom: `1px solid ${C.navyMid}`, minHeight: 60,
      }}>
        {open ? <LogoBativiz width={150} style={{ height: "auto" }} /> : <LogoMark width={36} height={36} />}
      </div>

      {open && clientNom && (
        <div style={{ padding: "12px 20px", borderBottom: `1px solid ${C.navyMid}` }}>
          <div style={{ fontSize: 13, fontWeight: 700 }}>{clientNom}</div>
          <div style={{ fontSize: 11, color: C.slateLight, marginTop: 2 }}>
            ● Sync : {syncLastRun ? new Date(syncLastRun).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"}
          </div>
        </div>
      )}

      <nav style={{ flex: 1, minHeight: 0, overflowY: "auto", overflowX: "hidden", paddingTop: 8 }}>
        {nav.map((n) => {
          const active = activePage === n.id;
          return (
            <div key={n.id} onClick={() => setActivePage(n.id)} style={{
              display: "flex", alignItems: "center", gap: 10, cursor: "pointer",
              padding: open ? "10px 20px" : "10px 0",
              justifyContent: open ? "flex-start" : "center",
              background: active ? "rgba(255,255,255,0.1)" : "transparent",
              color: active ? "#fff" : C.slateLight,
              borderLeft: active ? `3px solid ${C.accent}` : "3px solid transparent",
              fontSize: 13, fontWeight: active ? 700 : 400,
            }}>
              <n.icon size={18} />
              {open && <span>{n.label}</span>}
            </div>
          );
        })}
      </nav>

      <div style={{
        padding: open ? "12px 20px" : "12px 0", borderTop: `1px solid ${C.navyMid}`,
        display: "flex", alignItems: "center", gap: 10,
        justifyContent: open ? "flex-start" : "center",
      }}>
        <div onClick={signOut}
          style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: 8, color: C.slateLight }}>
          <IcoLogout size={16} />
          {open && <span style={{ fontSize: 12 }}>{profile?.prenom || "Déconnexion"}</span>}
        </div>
      </div>
    </aside>
  );
}
